
<div>
  <div id="rare-list-page" class="rfp-comon-space-declaration"></div>
  <div class="rfp-rr-most-ratings-list-050-or header">
    <p
      v-if="!noDataFound && ratingsListOption != 'carousel list view'"
      class="rfp-rr-most-ratings-list-051-or rfp-header-menu"
    >
      <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
      <span v-if="ratingsListOption === 'Ratings load more'">
        <span class="rfp-rr-most-ratings-list-053">
          {{ items.length }}
        </span>
      </span>
      <span v-else>
        <span
          v-if="
            items.length > reviewPaginationCount && items.length > toPages * reviewPaginationCount
          "
          class="rfp-rr-most-ratings-list-052-or"
        >
          {{ toPages }}
        </span>
        <span v-else class="rfp-rr-most-ratings-list-053">
          <span v-if="totalNoOfApprovedReviewsPagiantions === currentPageNo">{{
            totalNoOfApprovedReviews
          }}</span>
          <span v-else>{{ currentPageNo * reviewPaginationCount }}</span>
        </span>
      </span>
      <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
    </p>
    <p v-else class="rfp-rr-most-ratings-list-051-or rfp-header-menu">
      <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
      <span class="rfp-rr-most-ratings-list-053">
        <span v-if="ratingsListOption != 'carousel list view'">0</span>
        <span v-else>
          <template v-if="totalNoOfApprovedReviews === 0">
            {{ currentPaginationPage }}
          </template>
          <template v-if="totalNoOfApprovedReviews != 0">
            {{ currentPaginationPage + 1 }}
          </template>
        </span>
      </span>
      <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
    </p>
    <div class="header-right">
      <span
        v-if="ratingsListOption != 'carousel list view'"
        class="rfp-rr-most-ratings-list-061-or"
        @click="filterSortEnableFunction()"
      >
        <li color="white bold" class="rfp-rr-most-ratings-list-062-or">
          <p class="rfp-rr-most-ratings-list-063-or rfp-desktop-view">
            {{ sortDisplayData }}<i class="arrow-down"></i>
          </p>
          <p class="rfp-rr-most-ratings-list-064-or rfp-mobile-view">
            {{ sortDisplayDatamobileView }}<i class="arrow-down"></i>
          </p>
        </li>
      </span>
      <template v-if="supportContent != ''">
        <span class="rfp-common-space"></span>
        <span
          class="rfp-rr-most-ratings-list-055-or rfp-button-radius"
          @click="supportContentEnableFunction()"
          >?</span
        >
      </template>
      <span class="rfp-common-space"></span>
      <span
        v-if="ratingsListOption != 'carousel list view'"
        class="rfp-rr-most-ratings-list-068-or rr-sort float-left"
      >
        <li color="white bold" class="rfp-rr-most-ratings-list-069-or" @click="hamburger()">
          <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
          <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
          <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
          <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
        </li>
      </span>
    </div>
    <ul
      v-if="filterSortEnable"
      class="rfp-rr-most-ratings-list-066-or rr-sort-content rating-sort rfp-sort-arrow_box"
      :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
    >
      <li
        v-for="(x, listIndex) in sortList"
        :key="listIndex"
        class="rfp-rr-most-ratings-list-067-or black bold"
        @click="sortReviews(x.Key, x.Value)"
      >
        {{ x.Value }}
      </li>
    </ul>
    <ul
      v-if="supportContentEnable"
      class="rfp-rr-most-ratings-list-058-or rr-sort-content rating-sort-sm rfp-support-arrow_box"
    >
      <li class="rfp-rr-most-ratings-list-059-or black">
        <i class="rfp-rr-most-ratings-list-060-or caret up-arrow"></i
        ><span v-html="supportContent"></span>
      </li>
    </ul>
  </div>
  <div v-if="filterDiv">
    <div class="rfp-comon-space-declaration"></div>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
      <symbol id="rfp-ratings-checkmark" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-miterlimit="10"
          fill="none"
          d="M22.9 3.7l-15.2 16.6-6.6-7.1"
        ></path>
      </symbol>
    </svg>
    <div class="form-container">
      <div
        class="rfp-ratings-promoted-checkbox"
        :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
        @click="filterByStars('one')"
      >
        <input
          v-model="rfpFilterOne"
          type="checkbox"
          class="rfp-ratings-promoted-input-checkbox"
        />
        <label>
          <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
            <use xlink:href="#rfp-ratings-checkmark" />
          </svg>
          {{ oneStarText }}
        </label>
      </div>
      <div
        class="rfp-ratings-promoted-checkbox"
        :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
        @click="filterByStars('two')"
      >
        <input
          v-model="rfpFilterTwo"
          type="checkbox"
          class="rfp-ratings-promoted-input-checkbox"
        />
        <label>
          <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
            <use xlink:href="#rfp-ratings-checkmark" />
          </svg>
          {{ twoStarText }}
        </label>
      </div>
      <div
        class="rfp-ratings-promoted-checkbox"
        :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
        @click="filterByStars('three')"
      >
        <input
          v-model="rfpFilterThree"
          type="checkbox"
          class="rfp-ratings-promoted-input-checkbox"
        />
        <label>
          <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
            <use xlink:href="#rfp-ratings-checkmark" />
          </svg>
          {{ threeStarText }}
        </label>
      </div>
      <div
        class="rfp-ratings-promoted-checkbox"
        :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
        @click="filterByStars('four')"
      >
        <input
          v-model="rfpFilterFour"
          type="checkbox"
          class="rfp-ratings-promoted-input-checkbox"
        />
        <label>
          <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
            <use xlink:href="#rfp-ratings-checkmark" />
          </svg>
          {{ fourStarText }}
        </label>
      </div>
      <div
        class="rfp-ratings-promoted-checkbox"
        :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
        @click="filterByStars('five')"
      >
        <input
          v-model="rfpFilterFive"
          type="checkbox"
          class="rfp-ratings-promoted-input-checkbox"
        />
        <label>
          <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
            <use xlink:href="#rfp-ratings-checkmark" />
          </svg>
          {{ fiveStarText }}
        </label>
      </div>
      <span
        v-if="
          (filterCounts >= 2 && stars.oneStar) ||
          (filterCounts >= 2 && stars.twoStar) ||
          (filterCounts >= 2 && stars.threeStar) ||
          (filterCounts >= 2 && stars.fourStar) ||
          (filterCounts >= 2 && stars.fiveStar) ||
          (filterCounts >= 2 && sort.hlr) ||
          (filterCounts >= 2 && sort.lhr) ||
          (filterCounts >= 2 && sort.mh) ||
          (filterCounts >= 2 && sort.mr)
        "
        class="rfp-ratings-clearAll_filter"
        @click="clearAllStars"
        >{{ clearAll }}</span
      >
    </div>
  </div>
  <div class="rfp-comon-space-declaration"></div>
  <div class="rfp-rr-most-ratings-list-095-or rr-all-review-container">
    <div v-if="ratingsListOption != 'carousel list view'">
      <div v-if="ratingsListOption != 'Ratings load more'">
        <div>
          <paginate
            ref="paginator"
            name="items"
            :list="items"
            :per="reviewPaginationCount"
            class="rfp-rr-most-ratings-list-096-or paginate-list"
          >
            <template v-for="(item, itemIndex) in paginated('items')">
              <div v-if="item.NickName != ''" :key="`item-${itemIndex}`">
                <div
                  class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
                >
                  <div
                    v-if="
                      showHideLocation ||
                      showLabelNickname ||
                      userTypeShowHide ||
                      showHideAgeRange
                    "
                    class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left"
                  >
                    <p
                      class="rfp-rr-most-ratings-list-099-or rr-user-name"
                      itemprop="author"
                      itemscope
                      itemtype="https://schema.org/Person"
                      :class="{ 'label-hide-show': !showLabelNickname }"
                    >
                      <span class="black bold" itemprop="name">{{ item.NickName }}</span>
                    </p>
                    <p
                      v-if="showHideLocation"
                      class="rfp-rr-most-ratings-list-100-or rr-user-location"
                    >
                      <span>{{ item.Location }}</span>
                    </p>
                    <p
                      v-if="userTypeShowHide || item.UserType != null"
                      class="rfp-rr-most-ratings-list-133-or rr-user-name"
                    >
                      {{ userTypeDesc }} :<span> {{ item.UserType }}</span>
                    </p>
                    <p
                      v-if="item.AgeRange && showHideAgeRange"
                      class="rfp-rr-most-ratings-list-102-or rr-user-age"
                    >
                      {{ ageLabel }} : <span class="bold"> {{ item.AgeRange }}</span>
                    </p>
                  </div>
                  <div
                    class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right"
                    :class="{
                      'rfp-rare-full-width-conntainer':
                        !showHideLocation &&
                        !showLabelNickname &&
                        !userTypeShowHide &&
                        !showHideAgeRange,
                    }"
                  >
                    <span
                      class="rfp-rr-most-ratings-list-104-or review-stars"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <vue-star-rating
                        :increment="starRatingIncrementValue"
                        :max-rating="starRatingMaxRatingValue"
                        :inactive-color="starRatingInactiveColor"
                        :active-color="starRatingActiveColor"
                        :star-size="starRatingStarSize"
                        :rating="item.OverallRating"
                        :read-only="true"
                        :show-rating="false"
                      >
                      </vue-star-rating>
                    </span>
                    <span
                      v-if="showCreatedAt"
                      class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >- {{ item.CreatedDate }}</span
                    >
                    <div
                      class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                    ></div>
                    <h3
                      v-if="showHideReviewTitle"
                      class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                    >
                      {{ item.ReviewTitle }}
                    </h3>
                    <p
                      v-if="showHideReviewContent"
                      class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      v-html="item.ReviewContent"
                    ></p>
                    <div
                      v-if="showHideQualityRating"
                      class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                      :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                    >
                      <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">
                        {{ qualityOfProductLabel }}
                      </span>
                      <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer">
                        <span
                          class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                          :style="{ width: item.QualityRating * 20 + '%' }"
                        >
                        </span>
                      </span>
                      <span
                        class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold"
                      >
                        {{ item.QualityRating }}
                      </span>
                    </div>
                    <rfp-ratings-list-images
                      v-if="hasImages(item)"
                      :data="item.Images"
                      @openedmodal="(e) => openModal(e, item.Images)"
                    >
                    </rfp-ratings-list-images>
                    <div
                      v-if="showHideIsProductRecommended"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <div
                        class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                        itemprop="reviewBody"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <p v-if="!item.IsProductRecommended" style="margin-right: 0px">
                          <img
                            :src="notRecommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="notRecommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else style="margin-right: 0px">
                          <img
                            :src="recommendListIcon"
                            class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                            :alt="recommendIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>{{ item.IsRecommend }}</p>
                      </div>
                    </div>
                    <div
                      v-if="item.IsProductSuppliedFree && showFreeProduct"
                      class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                    >
                      <p>{{ isProductFreeDisplayText }}</p>
                    </div>
                    <div
                      class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                    ></div>
                    <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                      <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                        <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                          <span>{{ helpfulLabel }}</span>
                        </p>
                      </template>
                      <div
                        class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                      >
                        <template v-if="showFavorableReviewSection">
                          <p
                            v-if="item.IsHelpfulCookie == 'no'"
                            @click="defaultUpdateHelpfulReview(item.RRID)"
                          >
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="helpfullIcon"
                              class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                              :alt="helpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-123-or bold">{{
                              item.HelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <template v-if="showCriticalReviewSection">
                          <p
                            v-if="item.IsHelpfulCookie == 'no'"
                            @click="defaultUpdateNotHelpfulReview(item.RRID)"
                          >
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p v-else>
                            <img
                              :src="nonHelpfullIcon"
                              class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                              :alt="nonHelpfullIconAltText"
                              loading="lazy"
                            />
                          </p>
                          <p>
                            <span class="rfp-rr-most-ratings-list-126-or bold">{{
                              item.NotHelpfulCount
                            }}</span>
                          </p>
                        </template>
                        <p>
                          <a
                            v-if="item.IsReported == 'Report'"
                            class="rfp-rr-most-ratings-list-127-or aReported"
                            @click="ratingSummary(item.RRID)"
                            >{{ reportText }}</a
                          >
                          <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                            reportedText
                          }}</a>
                        </p>
                        <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                          <rfp-ratings-social-share
                            :url="currentPageUrl"
                            :title="item.ProductName"
                            :description="item.ReviewContent"
                            :quote="item.ReviewTitle"
                            :facebooks="facebookCaption"
                            :show-fb-media-texts="shareDisplayConfig"
                            :facebook-icons="facebookIcon"
                            :facebook-icon-alt="facebookIconAlt"
                          >
                            <social-sharing-network network="facebook">
                              <p v-if="facebookIcons == ''">
                                <span
                                  v-if="
                                    showFbMediaTexts == 'Icon and Text' ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                                ></span>
                              </p>
                              <p v-else>
                                <img
                                  v-if="
                                    (facebookIcons != '' &&
                                      showFbMediaTexts == 'Icon and Text') ||
                                    showFbMediaTexts == 'Icon'
                                  "
                                  :src="facebookIcons"
                                  :title="facebookIconAlt"
                                  class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                  :alt="facebookIconAlt"
                                  loading="lazy"
                                />
                              </p>
                              <span
                                v-if="
                                  showFbMediaTexts == 'Icon and Text' ||
                                  showFbMediaTexts == 'Text'
                                "
                                >{{ facebooks }}</span
                              >
                            </social-sharing-network>
                          </rfp-ratings-social-share>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rfp-comon-space-declaration"></div>
              </div>
              <div
                v-else
                :key="`norecord-${itemIndex}`"
                class="rfp-rr-most-ratings-list-129-or no_record__found"
              >
                {{ noRecordFound }}
              </div>
            </template>
          </paginate>
        </div>
        <div v-if="!noDataFound" class="rfp-rr-most-ratings-list-130-or rr-table-footer">
          <span class="rfp-rr-most-ratings-list-0520-or">{{ paginationShowing }}</span>
          <span
            v-if="
              items.length > reviewPaginationCount &&
              items.length > toPages * reviewPaginationCount
            "
            class="rfp-rr-most-ratings-list-052-or"
          >
            {{ toPages }}
          </span>
          <span v-else class="rfp-rr-most-ratings-list-053">
            <span v-if="totalNoOfApprovedReviewsPagiantions === currentPageNo">{{
              totalNoOfApprovedReviews
            }}</span>
            <span v-else>{{ currentPageNo * reviewPaginationCount }}</span>
          </span>
          <span>{{ paginationOutof }} {{ totalNoOfApprovedReviews }}</span>
          <div class="rfp-rr-most-ratings-list-132-or rr-table-footer-right float-right">
            <div id="navcontainer">
              <rfp-ratings-pagination-links
                :page-count="totalNoOfApprovedReviewsPagiantions"
                :click-handler="defaultPaginationCalculation"
                :prev-text="paginationPrevious"
                :next-text="paginationNext"
                :container-class="'paginate-links items paginate-ul'"
                active-class="number active paginate-li"
              >
              </rfp-ratings-pagination-links>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <template v-if="items.length === 0">
          <rfp-ratings-slide>
            <div class="rfp-rr-most-ratings-list-129-or no_record__found">
              {{ noRecordFound }}
            </div>
          </rfp-ratings-slide>
        </template>
        <template v-if="items.length != 0">
          <template v-for="(commentIndex, indexCommentsToShow) in commentsToShow">
            <div v-if="commentIndex < items.length + 1" :key="indexCommentsToShow">
              <div
                v-if="items[commentIndex - 1].NickName != ''"
                class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
              >
                <div
                  v-if="
                    showHideLocation || showLabelNickname || userTypeShowHide || showHideAgeRange
                  "
                  class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left"
                >
                  <p
                    class="rfp-rr-most-ratings-list-099-or rr-user-name"
                    itemprop="author"
                    itemscope
                    itemtype="https://schema.org/Person"
                    :class="{ 'label-hide-show': !showLabelNickname }"
                  >
                    <span class="black bold" itemprop="name">{{
                      items[commentIndex - 1].NickName
                    }}</span>
                  </p>
                  <p
                    v-if="showHideLocation"
                    class="rfp-rr-most-ratings-list-100-or rr-user-location"
                  >
                    <span>{{ items[commentIndex - 1].Location }}</span>
                  </p>
                  <p
                    v-if="userTypeShowHide && items[commentIndex - 1].UserType != null"
                    class="rfp-rr-most-ratings-list-133-or rr-user-name"
                  >
                    {{ userTypeDesc }} :<span> {{ items[commentIndex - 1].UserType }}</span>
                  </p>
                  <p
                    v-if="items[commentIndex - 1].AgeRange && showHideAgeRange"
                    class="rfp-rr-most-ratings-list-102-or rr-user-age"
                  >
                    {{ ageLabel }} :
                    <span class="bold"> {{ items[commentIndex - 1].AgeRange }}</span>
                  </p>
                </div>
                <div
                  class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right"
                  :class="{
                    'rfp-rare-full-width-conntainer':
                      !showHideLocation &&
                      !showLabelNickname &&
                      !userTypeShowHide &&
                      !showHideAgeRange,
                  }"
                >
                  <span
                    class="rfp-rr-most-ratings-list-104-or review-stars"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                  >
                    <vue-star-rating
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :rating="items[commentIndex - 1].OverallRating"
                      :read-only="true"
                      :show-rating="false"
                    >
                    </vue-star-rating>
                  </span>
                  <span
                    v-if="showCreatedAt"
                    class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >- {{ items[commentIndex - 1].CreatedDate }}</span
                  >
                  <div
                    class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                  ></div>
                  <h3
                    v-if="showHideReviewTitle"
                    class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                  >
                    {{ items[commentIndex - 1].ReviewTitle }}
                  </h3>
                  <p
                    v-if="showHideReviewContent"
                    class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    v-html="items[commentIndex - 1].ReviewContent"
                  ></p>
                  <rfp-ratings-list-images
                    v-if="hasImages(items[commentIndex - 1])"
                    :data="items[commentIndex - 1].Images"
                    @openedmodal="(e) => openModal(e, items[commentIndex - 1].Images)"
                  >
                  </rfp-ratings-list-images>
                  <div
                    v-if="showHideQualityRating"
                    class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                    :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                  >
                    <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">
                      {{ qualityOfProductLabel }}
                    </span>
                    <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer">
                      <span
                        class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                        :style="{ width: items[commentIndex - 1].QualityRating * 20 + '%' }"
                      >
                      </span
                    ></span>
                    <span class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold">
                      {{ items[commentIndex - 1].QualityRating }}
                    </span>
                  </div>
                  <div
                    v-if="showHideIsProductRecommended"
                    class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                  >
                    <div
                      class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                      itemprop="reviewBody"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <p
                        v-if="!items[commentIndex - 1].IsProductRecommended"
                        style="margin-right: 0px"
                      >
                        <img
                          :src="notRecommendListIcon"
                          class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                          :alt="notRecommendIconAltText"
                          loading="lazy"
                        />
                      </p>
                      <p v-else style="margin-right: 0px">
                        <img
                          :src="recommendListIcon"
                          class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                          :alt="recommendIconAltText"
                          loading="lazy"
                        />
                      </p>
                      <p>{{ items[commentIndex - 1].IsRecommend }}</p>
                    </div>
                  </div>

                  <div
                    v-if="items[commentIndex - 1].IsProductSuppliedFree && showFreeProduct"
                    class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                  >
                    <p>{{ isProductFreeDisplayText }}</p>
                  </div>
                  <div
                    class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                  ></div>
                  <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                    <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                      <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                        <span>{{ helpfulLabel }}</span>
                      </p>
                    </template>
                    <div
                      class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <template v-if="showFavorableReviewSection">
                        <p
                          v-if="items[commentIndex - 1].IsHelpfulCookie == 'no'"
                          @click="UpdateHelpfulReview(items[commentIndex - 1].RRID)"
                        >
                          <img
                            :src="helpfullIcon"
                            class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                            :alt="helpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else>
                          <img
                            :src="helpfullIcon"
                            class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                            :alt="helpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>
                          <span class="rfp-rr-most-ratings-list-123-or bold">{{
                            items[commentIndex - 1].HelpfulCount
                          }}</span>
                        </p>
                      </template>
                      <template v-if="showCriticalReviewSection">
                        <p
                          v-if="items[commentIndex - 1].IsHelpfulCookie == 'no'"
                          @click="UpdateNotHelpfulReview(items[commentIndex - 1].RRID)"
                        >
                          <img
                            :src="nonHelpfullIcon"
                            class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                            :alt="nonHelpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else>
                          <img
                            :src="nonHelpfullIcon"
                            class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                            :alt="nonHelpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>
                          <span class="rfp-rr-most-ratings-list-126-or bold">{{
                            items[commentIndex - 1].NotHelpfulCount
                          }}</span>
                        </p>
                      </template>
                      <p>
                        <a
                          v-if="items[commentIndex - 1].IsReported == 'Report'"
                          class="rfp-rr-most-ratings-list-127-or aReported"
                          @click="ratingSummary(items[commentIndex - 1].RRID)"
                          >{{ reportText }}</a
                        >
                        <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                          reportedText
                        }}</a>
                      </p>
                      <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                        <rfp-ratings-social-share
                          :url="currentPageUrl"
                          :title="items[commentIndex - 1].ProductName"
                          :description="items[commentIndex - 1].ReviewContent"
                          :quote="items[commentIndex - 1].ReviewTitle"
                          :facebooks="facebookCaption"
                          :show-fb-media-texts="shareDisplayConfig"
                          :facebook-icons="facebookIcon"
                          :facebook-icon-alt="facebookIconAlt"
                        >
                          <social-sharing-network network="facebook">
                            <p v-if="facebookIcons == ''">
                              <span
                                v-if="
                                  showFbMediaTexts == 'Icon and Text' ||
                                  showFbMediaTexts == 'Icon'
                                "
                                class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                              ></span>
                            </p>
                            <p v-else>
                              <img
                                v-if="
                                  (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                                  showFbMediaTexts == 'Icon'
                                "
                                :title="facebookIconAlt"
                                :src="facebookIcons"
                                class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                :alt="facebookIconAlt"
                                loading="lazy"
                              />
                            </p>
                            <span
                              v-if="
                                showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'
                              "
                              >{{ facebooks }}</span
                            >
                          </social-sharing-network>
                        </rfp-ratings-social-share>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="rfp-rr-most-ratings-list-129-or no_record__found">
                {{ noRecordFound }}
              </div>
              <div class="rfp-comon-space-declaration"></div>
            </div>
          </template>
          <button
            v-if="commentsToShow < totalNoOfApprovedReviews"
            class="rfp-ratings-load-more"
            @click="loadMoreHeaddercount"
          >
            <span>{{ showMoreText }}</span>
          </button>
        </template>
      </div>
    </div>
    <div v-else>
      <template v-if="items.length === 0">
        <rfp-ratings-slide>
          <div class="rfp-rr-most-ratings-list-129-or no_record__found">
            {{ noRecordFound }}
          </div>
        </rfp-ratings-slide>
      </template>
      <template v-if="items.length != 0">
        <rfp-ratings-carousel
          :autoplay="false"
          :autoplay-timeout="10000"
          :loop="false"
          :autoplay-hover-pause="true"
          :min-swipe-distance="8"
          pagination-active-color="#f30606"
          pagination-color="#efefef"
          :pagination-padding="10"
          :pagination-size="10"
          :per-page="1"
          :navigation-enabled="true"
          :pagination-enabled="false"
        >
          <template v-for="(item, index) in items">
            <rfp-ratings-slide v-if="item.NickName" :key="index">
              <div
                class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
                :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
              >
                <div
                  v-if="
                    showHideLocation || showLabelNickname || userTypeShowHide || showHideAgeRange
                  "
                  class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left-carousel"
                >
                  <p
                    class="rfp-rr-most-ratings-list-099-or rr-user-name"
                    itemprop="author"
                    itemscope
                    itemtype="https://schema.org/Person"
                    :class="{ 'label-hide-show': !showLabelNickname }"
                  >
                    <span class="black bold" itemprop="name">{{ item.NickName }}</span>
                  </p>
                  <p
                    v-if="showHideLocation"
                    class="rfp-rr-most-ratings-list-100-or rr-user-location"
                  >
                    <span>{{ item.Location }}</span>
                  </p>
                  <p
                    v-if="userTypeShowHide && item.UserType != null"
                    class="rfp-rr-most-ratings-list-133-or rr-user-name"
                  >
                    {{ userTypeDesc }} :<span> {{ item.UserType }}</span>
                  </p>
                  <p
                    v-if="item.AgeRange && showHideAgeRange"
                    class="rfp-rr-most-ratings-list-102-or rr-user-age"
                  >
                    {{ ageLabel }} : <span class="bold"> {{ item.AgeRange }}</span>
                  </p>
                </div>
                <div
                  class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right-carousel"
                  :class="{
                    'rfp-rare-full-width-conntainer':
                      !showHideLocation &&
                      !showLabelNickname &&
                      !userTypeShowHide &&
                      !showHideAgeRange,
                  }"
                >
                  <span
                    class="rfp-rr-most-ratings-list-104-or review-stars"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                  >
                    <vue-star-rating
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :rating="item.OverallRating"
                      :read-only="true"
                      :show-rating="false"
                    >
                    </vue-star-rating>
                  </span>
                  <span
                    v-if="showCreatedAt"
                    class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >- {{ item.CreatedDate }}</span
                  >
                  <div
                    class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"
                  ></div>
                  <h3
                    v-if="showHideReviewTitle"
                    class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
                  >
                    {{ item.ReviewTitle }}
                  </h3>
                  <p
                    v-if="showHideReviewContent"
                    class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    v-html="item.ReviewContent"
                  ></p>
                  <rfp-ratings-list-images
                    v-if="hasImages(item)"
                    :data="item.Images"
                    @openedmodal="(e) => openModal(e, item.Images)"
                  >
                  </rfp-ratings-list-images>
                  <div
                    v-if="showHideQualityRating"
                    class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-right mobile-quality-of-product"
                    :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                  >
                    <span class="rfp-rr-most-ratings-list-110-or rr-label float-left bold">{{
                      qualityOfProductLabel
                    }}</span>
                    <span class="rfp-rr-most-ratings-list-112-or rr-rating-bar-outer"
                      ><span
                        class="rfp-rr-most-ratings-list-113-or rr-rating-bar-inner"
                        :style="{ width: item.QualityRating * 20 + '%' }"
                      ></span
                    ></span>
                    <span
                      class="rfp-rr-most-ratings-list-114-or rr-label-info float-right bold"
                      >{{ item.QualityRating }}</span
                    >
                  </div>
                  <div
                    v-if="showHideIsProductRecommended"
                    class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                  >
                    <div
                      class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
                      itemprop="reviewBody"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <p v-if="!item.IsProductRecommended" style="margin-right: 0px">
                        <img
                          :src="notRecommendListIcon"
                          class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                          :alt="notRecommendIconAltText"
                          loading="lazy"
                        />
                      </p>
                      <p v-else style="margin-right: 0px">
                        <img
                          :src="recommendListIcon"
                          class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                          :alt="recommendIconAltText"
                          loading="lazy"
                        />
                      </p>
                      <p>{{ item.IsRecommend }}</p>
                    </div>
                  </div>

                  <div
                    v-if="item.IsProductSuppliedFree && showFreeProduct"
                    class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
                  >
                    <p>{{ isProductFreeDisplayText }}</p>
                  </div>
                  <div
                    class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"
                  ></div>
                  <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
                    <template v-if="showFavorableReviewSection || showCriticalReviewSection">
                      <p :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }">
                        <span>{{ helpfulLabel }}</span>
                      </p>
                    </template>
                    <div
                      class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
                      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                    >
                      <template v-if="showFavorableReviewSection">
                        <p
                          v-if="item.IsHelpfulCookie == 'no'"
                          @click="UpdateHelpfulReview(item.RRID)"
                        >
                          <img
                            :src="helpfullIcon"
                            class="rfp-rr-most-ratings-list-121-or image-setup-for-list"
                            :alt="helpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else>
                          <img
                            :src="helpfullIcon"
                            class="rfp-rr-most-ratings-list-122-or image-setup-for-list"
                            :alt="helpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>
                          <span class="rfp-rr-most-ratings-list-123-or bold">{{
                            item.HelpfulCount
                          }}</span>
                        </p>
                      </template>
                      <template v-if="showCriticalReviewSection">
                        <p
                          v-if="item.IsHelpfulCookie == 'no'"
                          @click="UpdateNotHelpfulReview(item.RRID)"
                        >
                          <img
                            :src="nonHelpfullIcon"
                            class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                            :alt="nonHelpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p v-else>
                          <img
                            :src="nonHelpfullIcon"
                            class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                            :alt="nonHelpfullIconAltText"
                            loading="lazy"
                          />
                        </p>
                        <p>
                          <span class="rfp-rr-most-ratings-list-126-or bold">{{
                            item.NotHelpfulCount
                          }}</span>
                        </p>
                      </template>
                      <p>
                        <a
                          v-if="item.IsReported == 'Report'"
                          class="rfp-rr-most-ratings-list-127-or aReported"
                          @click="ratingSummary(item.RRID)"
                          >{{ reportText }}</a
                        >
                        <a v-else class="rfp-rr-most-ratings-list-128-or aReported">{{
                          reportedText
                        }}</a>
                      </p>
                      <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
                        <rfp-ratings-social-share
                          :url="currentPageUrl"
                          :title="item.ProductName"
                          :description="item.ReviewContent"
                          :quote="item.ReviewTitle"
                          :facebooks="facebookCaption"
                          :show-fb-media-texts="shareDisplayConfig"
                          :facebook-icons="facebookIcon"
                          :facebook-icon-alt="facebookIconAlt"
                        >
                          <social-sharing-network network="facebook">
                            <p v-if="facebookIcons == ''">
                              <span
                                v-if="
                                  showFbMediaTexts == 'Icon and Text' ||
                                  showFbMediaTexts == 'Icon'
                                "
                                class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
                              ></span>
                            </p>
                            <p v-else>
                              <img
                                v-if="
                                  (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                                  showFbMediaTexts == 'Icon'
                                "
                                :title="facebookIconAlt"
                                :src="facebookIcons"
                                class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                                :alt="facebookIconAlt"
                                loading="lazy"
                              />
                            </p>
                            <span
                              v-if="
                                showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'
                              "
                              >{{ facebooks }}</span
                            >
                          </social-sharing-network>
                        </rfp-ratings-social-share>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </rfp-ratings-slide>
          </template>
        </rfp-ratings-carousel>
      </template>
    </div>
  </div>
  <div v-if="enableModal">
    <rfp-ratings-list-carousel-modal
      :images="carouselConfig.modalImages"
      :main-position="carouselConfig.mainPosition"
      :visible="carouselConfig.showModal"
      :show-actions="carouselConfig.showActions"
      :show-thumbnails="carouselConfig.showThumbnails"
      @closedmodal="closeModal"
    >
    </rfp-ratings-list-carousel-modal>
  </div>
</div>
